<template>
  <div>
    <div class="ds-text-sm sm:ds-text-base text-gray-700 font-normal border border-solid border-red-300 rounded bg-gray-100 py-2 px-3 mb-4" v-if="variant === 'banner'">
      <p>
        <i class="sr-2 sr-v2-exclamation-circle text-red-300 mr-1"></i>
        <span>Sending messages to college coaches is a Pro feature. </span>
        <br class="md:hidden">
        <a :href="link"
           target="_blank"
           :data-segment-track="linkTracking"
           data-segment-cta_name="cannot_send_messages"
           :data-segment-cta_page="ctaPage"
        >{{ linkText }} </a>
        <span>to unlock the messaging system.</span>
      </p>
    </div>
    
    <div v-else-if="variant === 'hero'">
      <div class="EmptyState-image col-xs-12">
        <img src=/ember_app/dist/images/empty-state_msgs-lock.svg>
      </div>
      
      <h3 class="EmptyState-message col-xs-12">Sending messages to college coaches is a Pro feature.</h3>
      
      <p class="EmptyState-action col-xs-12">
        <a :href="link"
           target="_blank"
           :data-segment-track="linkTracking"
           :data-segment-cta_name="heroLinkCtaNameTracking"
           :data-segment-cta_page="ctaPage"
        >{{ linkText }} </a>
        <span>to unlock the messaging system.</span>
      </p>
    </div>
  </div>
</template>

<script>
  import api from '@/services/api';

  export default {
    props: {
      variant: {type: String, default: 'banner'},
      ctaPage: String,
    },
    computed: {
      isUserFree() {
        return !!api.clientData('user_is_free');
      },
      isUserExpired() {
        return !!api.clientData('user_is_expired');
      },
      isUserIdentityVerified() {
        return !!api.clientData('is_identity_verified');
      },
      link() {
        if (this.isUserIdentityVerified) {
          return '/pricing';
        }         
        
        return api.clientData('calendly_meeting_url');
      },
      linkText() {
        if (this.isUserExpired) {
          return 'Reactivate Pro';  
        }
        
        if (this.isUserIdentityVerified) {
          return 'Upgrade your account';
        }
        
        return 'Schedule a Call';
      },
      linkTracking() {
        if (this.isUserExpired) {
          return 'expired_cta';
        }
        
        if (this.isUserIdentityVerified) {
          return 'upgrade_account_cta';
        }
        
        return 'get_verified_cta';
      },
      heroLinkCtaNameTracking() {
        if (this.isUserExpired) {
          return 'purchase_membership';
        }
        
        if (this.isUserIdentityVerified) {
          return 'upgrade_account';
        }
        
        return 'schedule_a_call';
      }
    }
  }
</script>